(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
"use strict";

jQuery(document).ready(function ($) {

    $(".edit-content-link").hover(function () {
        // $(".edit-content-link").stop().animate({
        //     opacity: 0.6
        // }, 100);
        // $(this).stop().animate({
        //     opacity: 1
        // }, 300);
        $(".edit-content-link").addClass("effect");
        $(this).removeClass("effect");
    }, function () {
        $(".edit-content-link").removeClass("effect");
        // $(".edit-content-link").stop().animate({
        //     opacity: 1
        // }, 50);
    });
    $(".input-container").click(function () {
        $(".input-container").removeClass("active");
        $(this).addClass("active");
    });
    $(".fixed-btn").fadeOut(500);

    $(window).bind("scroll", function () {
        var st = $(this).scrollTop();
        // console.log(st);
        checkpage(st);
    });

    function checkpage(st) {
        if (st >= $(".p2").offset().top) {
            $(".fixed-btn").fadeIn(500);
        } else {
            $(".fixed-btn").fadeOut(500);
        }
    }
    new WOW().init();
    setTimeout(function () {
        $("html, body").animate({
            scrollTop: $(".p4").offset().top
        }, 600);
    }, 1200);
    $(".page-scroll").bind("click", function (event) {
        var $anchor = $(this);
        var $body = $("html, body");
        $body.animate({
            scrollTop: $($anchor.data("ancher")).offset().top
        }, 600);
        event.preventDefault();
    });
});

},{}],2:[function(require,module,exports){
"use strict";

var canvasWidth = $("#canvas_game").data("canvas-width");
var canvasHeight = $("#canvas_game").data("canvas-height");
var canvas_game = new fabric.Canvas("canvas_game");
var uploadedImgObj; //儲存上傳圖片物件

//組合使用者頭像與背景用的canvas======
var canvas_Resultgame = new fabric.Canvas("canvas_Resultgame");
var canvasWidth_r = $("#canvas_Resultgame").data("canvas-width");
var canvasHeight_r = $("#canvas_Resultgame").data("canvas-height");
var uploadedImgObj_r;

var send2server_flag = false;
//========上傳圖片各種參數=============
var uploadedImgOriginWidth, uploadedImgOriginHeight;
var isPictureHeight = false,
    isPictureWidth = false;
var extendPixel = 0;
var horizontalBorderLimit = 0; //水平邊界
var verticalBorderLimit = 0; //垂直邊界
var imageScale = 1;
//=====================================
var userPlayFlag = false;
var gameOverlayPath = "images/game-overloay.png";
var mobileFlag = $("body").attr("data-mobile");

//fabric 有自帶壓縮 for jpeg能指定圖片品質
var fileType = "jpeg";

$.ajaxSetup({
    cache: true
});

$(document).ready(function () {
    initialization();
    SetOverlayImage(canvas_game, gameOverlayPath);
    CanvasEvent(canvas_game);

    // 上傳照片============================================
    $("#uploadedImg").change(function (event) {

        var flag = CheckFileSize(event.target.files);
        if (!flag) {
            alert("Please choose an image < 5MB.");
            return;
        } else {
            // SetOverlayImage(canvas_game,null);
            RemoveCanvasObj(uploadedImgObj);
            initialization();
            InitialParam();

            var fileReader = new FileReader();
            fileReader.readAsDataURL(event.target.files[0]);

            fileReader.onload = function (event) {
                var imgObj = new Image();
                imgObj.src = event.target.result;
                imgObj.onload = function () {
                    CheckImg(imgObj);
                    uploadedImgObj = AddImgToCanvas(canvas_game, imgObj, imageScale, 0, 0);
                };
            };
            userPlayFlag = true;
        }
    });

    // send to server
    $("#gameEnd").click(function (event) {
        if (!userPlayFlag) {
            alert("請選擇一張照片或使用fb大頭照！");
            return;
        }
        var gameitem = CreateResultPic(canvas_game, 0, 0, canvasWidth, canvasHeight);
        apidata["gameitem_result"] = SendImgToServer(gameitem);
        // console.log("fb share img url:" + apidata["gameitem_result"]);
        // var imgBg = new Image();
        // imgBg.onload = function () {
        // uploadedImgObj_r = AddImgToCanvas(canvas_Resultgame, imgBg, 1, 0, 0, false, false);

        // var imgObj = new Image();
        // imgObj.src = gameitem;
        // imgObj.onload = function () {
        // CheckImg(imgObj);
        // canvas,imgObj,imageScale,x,y,hasControls,hasBorders,angle
        // imgObj.width=fbImportImgSize;
        // imgObj.height=fbImportImgSize;
        // if($(window).width()<=750){
        //     uploadedImgObj = AddImgToCanvas(canvas_Resultgame,imgObj,0.18,365,45,false,false,5);
        // }else{
        // uploadedImgObj = AddImgToCanvas(canvas_Resultgame,imgObj,0.5,365,45,false,false,5);
        // }

        // uploadedImgObj.setAngle(5).setCoords();
        // canvas_game.renderAll();

        // gameitem = CreateResultPic(canvas_Resultgame, 0, 0, canvasWidth_r, canvasHeight_r);

        // }
        // }

        showResult();

        //game.php 的表單要帶入的資料
        var imgPath = apidata["gameitem_result"].split("/uploads/");
        var eventUrl = $("meta[property='og:url']").attr("content");
        var fbid = $("meta[property='fb:app_id']").attr("content");
        var fblink = eventUrl + "share.php?img=" + apidata["gameitem_result"]; //share.php 分享圖片形式

        // var fblink = eventUrl + "share.php?img=" + apidata["gameitem_result"]; 
        $("[name=img]").val("uploads/" + imgPath[1]);
        //手機版分享使用導向的方式
        $("[name=redirect]").val("https://www.facebook.com/dialog/share?app_id=" + fbid + "&href=" + fblink + "&redirect=" + eventUrl);
        // console.log("fblink:" + fblink);

        //    $(".loading").fadeOut('400',function(){
        //         $("html, body").stop().animate({scrollTop:1597}, 500, 'swing', function() { });
        //    });
    });

    $("#save").click(function () {
        ImgDownload(apidata["gameitem_result"]);
    });

    $("#resize_slider").slider({
        // orientation: "vertical",
        range: "min",
        min: 0,
        max: 50,
        value: 0,
        slide: function slide(event, ui) {
            $("#amount").val(ui.value);
            ReSizeImg(uploadedImgObj, ui.value, uploadedImgOriginWidth, uploadedImgOriginHeight);
        }
    });

    if (mobileFlag) {
        $("#resize_slider").slider("option", {
            orientation: "vertical"
        });
    }

    $("#amount").val($("#resize_slider").slider("value"));

    var angle = 0;
    $("#rotareBtn").click(function (event) {
        if (angle >= 360) {
            angle = 0;
        } else {
            angle = angle + 90;
        }

        uploadedImgObj.setAngle(angle).setCoords();
        canvas_game.renderAll();
    });
});
$("#usefbPic").click(function () {
    reqFbPic();
});

function reset() {
    RemoveCanvasObj(uploadedImgObj);
    // InitialParam();
    removeAll();
    canvas_game.renderAll();
    initialization();
    imageScale = 1;
    send2server_flag = false;
    userPlayFlag = false;
    $("#step2Msg").val("");
    $("#step2Input").val("");
    // picChoice = 0;
    $("form").find("input, textarea").val("");
}

function initialization() {
    // SetOverlayImage(canvas_game, null);
    SetOverlayImage(canvas_game, gameOverlayPath);
    $(".tootip").hide();
    canvas_game.renderAll();
}

function ReSizeImg(obj, scaleValue, originWidth, originHeight) {
    var Scale = (100 + scaleValue) / 100;
    var changeWidth = originWidth * Scale;
    var changeHeight = originHeight * Scale;
    if (isPictureWidth) {
        obj.width = changeWidth;
        obj.height = changeHeight;
        horizontalBorderLimit = extendPixel + (changeWidth - originWidth) * imageScale;
        verticalBorderLimit = (changeHeight - originHeight) * imageScale;
    } else if (isPictureHeight) {
        obj.width = changeWidth;
        obj.height = changeHeight;
        horizontalBorderLimit = (changeWidth - originWidth) * imageScale;
        verticalBorderLimit = extendPixel + (changeHeight - originHeight) * imageScale;
    } else {
        obj.width = changeWidth;
        obj.height = changeHeight;
        horizontalBorderLimit = (changeWidth - originWidth) * imageScale;
        verticalBorderLimit = (changeHeight - originHeight) * imageScale;
    }
    canvas_game.renderAll();
}

function SetOverlayImage(canvas, path) {
    canvas.setOverlayImage(path, canvas.renderAll.bind(canvas));
}

function CanvasEvent(canvas) {
    canvas.on({
        "object:moving": function objectMoving(e) {
            e.target.opacity = 0.5;
            var obj = e.target;
            obj.setCoords();
            //top corner
            if (obj.getBoundingRect().top < -verticalBorderLimit) {
                obj.top = Math.max(obj.top, obj.top - obj.getBoundingRect().top) - verticalBorderLimit;
            }
            // left corner
            if (obj.getBoundingRect().left < -horizontalBorderLimit) {
                obj.left = Math.max(obj.left, obj.left - obj.getBoundingRect().left) - horizontalBorderLimit;
            }
            //bottom corner
            if (obj.getBoundingRect().top + obj.getBoundingRect().height > obj.canvas.height + verticalBorderLimit) {
                obj.top = Math.min(obj.top, obj.canvas.height - obj.getBoundingRect().height + obj.top - obj.getBoundingRect().top) + verticalBorderLimit;
            }
            //right corner
            if (obj.getBoundingRect().left + obj.getBoundingRect().width > obj.canvas.width + horizontalBorderLimit) {
                obj.left = Math.min(obj.left, obj.canvas.width - obj.getBoundingRect().width + obj.left - obj.getBoundingRect().left) + horizontalBorderLimit;
            }
            // console.log("object:moving="+e.target);
        },
        "object:modified": function objectModified(e) {
            e.target.opacity = 1;
            // console.log("object:modified="+e.target);
        }
    });
}

function CreateResultPic(canvas_box, dx, dy, dWidth, dHeight) {
    var ctx = canvas_box.getContext ? canvas_box.getContext("2d") : null;
    dx = dx > 0 ? dx : 0;
    dy = dy > 0 ? dy : 0;
    dWidth = dWidth > 0 ? dWidth : 200;
    dHeight = dHeight > 0 ? dHeight : 200;
    var sx = 0;
    var sy = 0;
    var sWidth = dWidth;
    var sHeight = dHeight;
    var baseimage = new Image();
    //   var safari   = navigator.userAgent.indexOf("Safari")>-1;
    //   if(!safari){
    //      ctx.drawImage(baseimage,dx,dy,dWidth,dHeight);
    //   }else{
    ctx.drawImage(baseimage, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight);
    //   }

    // var dataURL = canvas_box.toDataURL("image/png");
    var dataURL = canvas_box.toDataURL({
        format: fileType,
        quality: 0.3
    });
    document.getElementById("canvasImg").src = dataURL;
    return dataURL;
}

function CreateResultPic_Step2(canvas_box, dx, dy, dWidth, dHeight) {
    var ctx = canvas_box.getContext ? canvas_box.getContext("2d") : null;
    dx = dx > 0 ? dx : 0;
    dy = dy > 0 ? dy : 0;
    dWidth = dWidth > 0 ? dWidth : 200;
    dHeight = dHeight > 0 ? dHeight : 200;
    var sx = 0;
    var sy = 0;
    var sWidth = dWidth;
    var sHeight = dHeight;
    var baseimage = new Image();
    ctx.drawImage(baseimage, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight);

    // var dataURL = canvas_box.toDataURL("image/png");
    var dataURL = canvas_box.toDataURL({
        format: fileType,
        quality: 0.5
    });
    document.getElementById("step02pic").src = dataURL;
    return dataURL;
}

function ImgDownload(imgurl) {
    // var isChrome = !!window.chrome && !!window.chrome.webstore;
    var is_safari = navigator.userAgent.indexOf("Safari") > -1;
    // var link = document.createElement("a");
    // var imgPath = imgurl.split("/uploads/");

    if (mobileFlag && is_safari) {
        $(".tootip").show(300);
        setTimeout(function () {
            $(".tootip").hide(300);
        }, 1500);
    } else {
        var a = $("<a>").attr("href", imgurl).attr("download", "img." + fileType).appendTo("body");

        a[0].click();
        a.remove();
    }
    // var imgPath = apidata["user_canvas_pic_url"].split("/uploads/");
    // link.href = "download.php?img=" + imgPath[1];
    // link.href = imgurl;
    // link.download = "mypainting." + fileType;
    // link.click();
    // link.remove();
}

function SendImgToServer(imgurl) {
    // 鎖住該按鈕避免重複送出=====
    //  $('#save').prop('disabled', true);
    //  $('#fbShare').prop('disabled', true);
    // 自動存放至路徑資料夾內
    $.ajax({
        type: "POST",
        url: "save.php",
        dataType: "json",
        async: false,
        data: {
            // imgBase64: dataURL
            base64: imgurl
        }
    }).done(function (o) {
        //   console.log('res:'+o.msg);
        //   console.log('resImg:'+o.data.imgUrl);
        apidata["user_canvas_pic_url"] = o.data.imgUrl;
        send2server_flag = true;
        //   $('#save').prop('disabled', false);
        //   $('#fbShare').prop('disabled', false);
    });
    return apidata["user_canvas_pic_url"];
}

function CheckFileSize(obj) {
    var filelist = obj;
    var str = "";
    var maxSize = $("#uploadedImg").data("max-size");
    for (var i = 0; i < filelist.length; i++) {
        var file = filelist[i];
        str += "name：" + escape(file.name) + "\n" + //檔名
        "type：" + file.type + "\n" + //檔案類型
        "size：" + file.size + "\n"; //檔案大小
    }
    // console.log(str);
    if (file.size >= maxSize) {
        return false;
    } else {
        return true;
    }
}

function CheckImg(imgObj) {
    if (imgObj.width > imgObj.height) {
        imageScale = canvasHeight / imgObj.height;
        isPictureWidth = true;
        extendPixel = Math.round(imgObj.width * imageScale - canvasWidth);
        horizontalBorderLimit = extendPixel;
    } else if (imgObj.width < imgObj.height) {
        imageScale = canvasWidth / imgObj.width;
        isPictureHeight = true;
        extendPixel = Math.round(imgObj.height * imageScale - canvasHeight);
        verticalBorderLimit = extendPixel;
    } else {
        imageScale = canvasHeight / imgObj.height;
        isPictureWidth = false;
        isPictureHeight = false;
    }
    uploadedImgOriginHeight = imgObj.height;
    uploadedImgOriginWidth = imgObj.width;
}

function AddImgToCanvas(canvas, imgObj, imageScale, x, y, hasControls, hasBorders, angleValue) {
    var hasControls_flag = typeof hasControls !== "undefined" ? hasControls : false;
    var hasBorders_flag = typeof hasBorders !== "undefined" ? hasBorders : false;
    var x = typeof x !== "undefined" ? x : false;
    var y = typeof y !== "undefined" ? y : false;
    var angleValue = typeof angleValue !== "undefined" ? angleValue : 0;
    var image = new fabric.Image(imgObj);

    image.set({
        left: x,
        top: y,
        scaleX: imageScale,
        scaleY: imageScale,
        hasControls: hasControls_flag,
        hasBorders: hasBorders_flag,
        angle: angleValue
    });
    if (x == 0 && y == 0) {
        canvas.centerObject(image);
    }
    canvas.add(image);
    canvas.renderAll();
    return image;
}

function InitialParam() {
    isPictureHeight = false, isPictureWidth = false;
    extendPixel = 0;
    horizontalBorderLimit = 0; //水平邊界
    verticalBorderLimit = 0; //垂直邊界
    imageScale = 1;
    $("#amount").val(0);
    $("#resize_slider").slider("value", 0);
}

function RemoveCanvasObj(canvas_ele) {
    if (typeof canvas_ele !== "undefined") {
        canvas_ele.remove();
        canvas_game.renderAll();
    }
}

function removeAll() {
    canvas_game.clear();
    canvas_game.renderAll();
}

function reqFbPic() {

    initialization();
    InitialParam();
    RemoveCanvasObj(uploadedImgObj);
    var fbimg = new Image();
    fbimg.setAttribute("crossOrigin", "anonymous");
    fbimg.src = "https://graph.facebook.com/" + apidata["uid"] + "/picture?type=square&width=" + fbImportImgSize + "&height=" + fbImportImgSize;
    fbimg.onload = function (e) {
        CheckImg(fbimg);
        uploadedImgObj = AddImgToCanvas(canvas_game, fbimg, imageScale, 0, 0);
        userPlayFlag = true;
    };
}

// function createStep02pic() {
//     var gameitem = CreateResultPic_Step2(canvas_game, 0, 0, canvasWidth, canvasHeight);
//     var imgObj = new Image();
//     imgObj.src = gameitem;
//     imgObj.onload = function () {
//         apidata["gameitem_result"] = gameitem;
//         var userPic = SendImgToServer(gameitem);
//         sessionStorage.userPic = userPic;
//         //使用者的照片存放在此
//         console.log("userPic:" + sessionStorage.userPic);
//     }
// }

// game step handel==============
$("#step01").css("display", "none");
$("#step02").css("display", "none");

TweenMax.to("#step01", 0.8, {
    opacity: 0,
    ease: "Cubic.easeOut"
});
TweenMax.to("#step02", 0.8, {
    opacity: 0,
    ease: "Cubic.easeOut"
});

$("#gameReset").click(function (event) {
    // 回到第一頁時刪除完圖匡的結果
    reset();
    TweenMax.to("#step03", 0.8, {
        opacity: 0,
        ease: "Cubic.easeOut",
        onComplete: function onComplete() {
            $("#step02").css("display", "none");
            $("#startgame").css("display", "block");
        }
    });
    TweenMax.to("#startgame", 0.8, {
        opacity: 1,
        delay: 0.7,
        ease: "Cubic.easeOut"
    });
});

$("#step1BtnNext").click(function () {
    TweenMax.to("#step01", 0.8, {
        opacity: 0,
        ease: "Cubic.easeOut",
        onComplete: function onComplete() {
            $("#step02").css("display", "block");
            $("#step01").css("display", "none");
        }
    });
    TweenMax.to("#step02", 0.8, {
        opacity: 1,
        delay: 0.7,
        ease: "Cubic.easeOut"
    });
});

$("#step1BtnBack").click(function () {
    TweenMax.to("#step01", 0.8, {
        opacity: 0,
        ease: "Cubic.easeOut",
        onComplete: function onComplete() {
            $("#step01").css("display", "none");
            $("#startgame").css("display", "block");
        }
    });
    TweenMax.to("#startgame", 0.8, {
        opacity: 1,
        delay: 0.7,
        ease: "Cubic.easeOut"
    });
    reset();
});

function showResult() {
    TweenMax.to("#step01", 0.8, {
        opacity: 0,
        ease: "Cubic.easeOut",
        onComplete: function onComplete() {
            $("#step02").css("display", "block");
            $("#step01").css("display", "none");
        }
    });
    TweenMax.to("#step02", 0.8, {
        opacity: 1,
        delay: 0.7,
        ease: "Cubic.easeOut"
    });
}

},{}]},{},[2,1]);
